var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wiki-content-article"},[_c('FullText',{model:{value:(_vm.body),callback:function ($$v) {_vm.body=$$v},expression:"body"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }